import FAQService from '@/service/faq'
export default {
  getListFAQ ({commit}, payload) {
    return new Promise((resolve, reject) => {
      FAQService.getListFAQ(payload.page, payload.per_page, payload.search, payload.sort, payload.status, payload.group_faq_id).then(res => {
        commit('getListFAQ', res.data)
        resolve(res.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  createFAQ ({commit}, payload) {
    return new Promise((resolve, reject) => {
      FAQService.createFAQ(payload.faq).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  showFAQ ({commit}, payload) {
    commit('clearFaqSelect')
    return new Promise((resolve, reject) => {
      FAQService.showFAQ(payload.faq).then(res => {
        commit('showFaq', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  destroyFAQ ({commit}, payload) {
    return new Promise((resolve, reject) => {
      FAQService.destroyFAQ(payload.faq).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  closeFAQ ({commit}, payload) {
    return new Promise((resolve, reject) => {
      FAQService.closeFAQ(payload.faq).then(res => {
        commit('showFaq', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  openFAQ ({commit}, payload) {
    return new Promise((resolve, reject) => {
      FAQService.openFAQ(payload.faq).then(res => {
        commit('showFaq', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  updateFAQ ({commit}, payload) {
    return new Promise((resolve, reject) => {
      FAQService.updateFAQ(payload.faq).then(res => {
        commit('showFaq', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  getListCommentOfFAQ ({commit}, payload) {
    return new Promise((resolve, reject) => {
      FAQService.getListCommentOfFAQ(payload.faq).then(res => {
        commit('getListCommentOfFAQ', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  createCommentOfFAQ ({commit}, payload) {
    return new Promise((resolve, reject) => {
      FAQService.createCommentOfFAQ(payload.faq, payload.comment).then(res => {
        commit('createCommentOfFAQ', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  createChildrenCommentOfChecklistItem ({commit}, payload) {
    return new Promise((resolve, reject) => {
      FAQService.createCommentOfFAQ(payload.faq, payload.comment).then(res => {
        commit('createChildrenCommentOfChecklistItem', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  destroyCommentOfFAQ ({commit}, payload) {
    return new Promise((resolve, reject) => {
      FAQService.destroyCommentOfFAQ(payload.faq, payload.comment).then(res => {
        commit('destroyCommentOfFAQ', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  destroyChildrenCommentOfFAQ ({commit}, payload) {
    return new Promise((resolve, reject) => {
      FAQService.destroyCommentOfFAQ(payload.faq, payload.comment).then(res => {
        commit('destroyChildrenCommentOfFAQ', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  showCommentOfFAQ ({commit}, payload) {
    return new Promise((resolve, reject) => {
      FAQService.showCommentOfFAQ(payload.faq, payload.comment).then(res => {
        // commit('createChildrenCommentOfChecklistItem', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  updateCommentOfFAQ ({commit}, payload) {
    return new Promise((resolve, reject) => {
      FAQService.updateCommentOfFAQ(payload.faq, payload.comment).then(res => {
        commit('updateCommentOfFAQ', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  updateChildrenCommentOfFAQ ({commit}, payload) {
    return new Promise((resolve, reject) => {
      FAQService.updateCommentOfFAQ(payload.faq, payload.comment).then(res => {
        commit('updateChildrenCommentOfFAQ', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/module/faq/actions.js